/* src/app/system-utils/search-input-new/search-input-new.component.scss */
nz-select {
  width: 100%;
}
.loading-icon {
  margin-right: 8px;
}
/*# sourceMappingURL=search-input-new.component.css.map */
